import React from "react";
import { Animated } from "react-animated-css";
import { connect } from "react-redux";
// import { Link, Redirect, useHistory } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import LoginPhone from "../../containers/loginPhone/loginPhone.components";
import LoginUsername from "../../containers/loginUsername/loginUsername.component";
import { selectLoginStep } from "../../redux/login/login.selectors";
import { selectUserCookie } from "../../redux/login/login.selectors";
// import { selectUserToken } from "../../redux/user/user.selectors";
import { LoginStyled } from "./login.styled";

const Login = ({ loginStep, selectUserCookie }) => {
  // const history = useHistory();

  // history.push("/sadf");
  // if (selectUserCookie) {
  //   window.location.href = `/app2/home`;
  // }
  return (
    <LoginStyled>
      <div className="d-flex flex-column align-items-center">
        <LoginPhone loginStep={loginStep} />
        <Animated
          // animationIn="bounceInDown"
          animationOut="bounceOutDown"
          animationInDuration={0}
          animationOutDuration={750}
          isVisible={!(loginStep > 0)}
          className="animated position-relative overflow-hidden"
        >
          {/* <LoginUsername /> */}
        </Animated>
      </div>
    </LoginStyled>
  );
};

const mapStateToProps = createStructuredSelector({
  // userToken: selectUserToken,
  loginStep: selectLoginStep,
  selectUserCookie: selectUserCookie,
});

export default connect(mapStateToProps)(Login);
